// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__tdQBe","row":"styles_row__1J3gz"};